<poker-core-lazy-placeholder [inputData]="{ item: item }" [componentName]="'PokerTwitchFeedLWComponent'"></poker-core-lazy-placeholder>
